module.exports = __webpack_public_path__ + "static/media/playlist.b7dd8337.svg";